'use client';

import React from 'react';
import NextLink from 'next/link';
import { useTranslations } from 'next-intl';
import { CaretDown, Sidebar } from '@phosphor-icons/react';
import { Box, Button, Divider, ListItem, ListItemButton, Menu, Stack, Typography } from '@unity/cloud-ui';
import { SidebarContext } from '@/components/sidebar/sidebar-provider';
import type { ProductHeaderDataType } from '@/lib/content-loader/types';

export const ProductHeaderMobile = (props: ProductHeaderDataType) => {
  const { title, quickAccess } = props;
  const t = useTranslations();
  const { toggleSidebar } = React.useContext(SidebarContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSidebarClick = () => {
    toggleSidebar();
  };

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Stack direction="row" gap={2} alignItems="center">
          <Button
            data-testid="mobile-sidebar-toggler"
            aria-label={t('product-header:sidebar-menu:aria-label')}
            color="default"
            onClick={handleSidebarClick}
          >
            <Sidebar size={24} />
          </Button>
          <Divider orientation="vertical" sx={{ height: 20 }} />
          <Typography variant="h3">{title}</Typography>
        </Stack>
        <Box>
          <Button
            data-testid="quick-access-mobile-menu-toggler"
            aria-label={t('product-header:menu:aria-label')}
            color="default"
            onClick={handleMenuClick}
          >
            {<CaretDown size={24} />}
          </Button>
          <Menu open={open} anchorEl={anchorEl} onClose={handleClose} disableScrollLock>
            {quickAccess?.map(({ title, href }) => (
              <ListItem key={title} onClick={handleClose}>
                <ListItemButton component={NextLink} href={href} sx={{ '&:hover': { color: 'inherit' } }}>
                  {title}
                </ListItemButton>
              </ListItem>
            ))}
          </Menu>
        </Box>
      </Stack>
    </>
  );
};
